import { components, isEmpty } from '@/utils'

import { basic, core } from '@/components/g/checkbox/mixins'

import render from './render'

export default {
  name: components.switch,

  mixins: [ core, basic ],

  props: {
    fluid: Boolean
  },

  computed: {
    $_class() {
      return {
        [`${components.switch}`]: true,
        [`${components.switch}--checked`]: this.checked,
        [`${components.switch}--disabled`]: this.disabled,
        [`${components.switch}--unknown`]: isEmpty(this.proxy),
        [`${components.switch}--labeled`]: !!this.label,
        [`${components.switch}--outline`]: this.outline,
        [`${components.switch}--fluid`]: this.fluid
      }
    }
  },

  render
}
